/*
 * Tablas de Cocina – cambio de variante instantáneo (producto y producto destacado de portada).
 *
 * El tema (Horizon) vuelve a descargar la página completa del producto cada vez que el
 * cliente elige otra madera o tamaño, y no cambia el precio hasta que llega la respuesta.
 * Este script:
 *   1. Guarda en memoria esas respuestas (?option_values=…) para no pedirlas dos veces.
 *   2. Precarga, cuando el navegador está libre, todas las combinaciones de variantes del
 *      producto, y la combinación sobre la que el cliente pasa el dedo o el mouse.
 * Así, al elegir una opción, la respuesta ya está lista y el precio cambia al instante.
 * No modifica ningún archivo del tema: si algo falla, el tema funciona como siempre.
 */
(function () {
  'use strict';

  if (window.__tdcVariantSpeed || typeof window.fetch !== 'function') return;
  window.__tdcVariantSpeed = true;

  var TTL_MS = 5 * 60 * 1000; // las respuestas se reutilizan hasta 5 minutos
  var MAX_ENTRIES = 40;
  var MAX_COMBINATIONS = 8; // nuestros productos tienen 2 o 4 combinaciones

  var originalFetch = window.fetch.bind(window);
  var cache = new Map(); // url absoluta -> { time, promise }

  function abortError() {
    try {
      return new DOMException('Aborted', 'AbortError');
    } catch (e) {
      var err = new Error('Aborted');
      err.name = 'AbortError';
      return err;
    }
  }

  /** Devuelve la URL absoluta si la petición es de variantes de producto; si no, null. */
  function variantUrl(input, init) {
    if (typeof input !== 'string' && !(input instanceof URL)) return null;
    var method = (init && init.method) || 'GET';
    if (String(method).toUpperCase() !== 'GET') return null;
    var url = new URL(String(input), window.location.href);
    if (url.origin !== window.location.origin) return null;
    if (url.pathname.indexOf('/products/') === -1) return null;
    if (!url.searchParams.has('option_values')) return null;
    return url.href;
  }

  function load(key) {
    var hit = cache.get(key);
    if (hit && Date.now() - hit.time < TTL_MS) return hit.promise;

    var promise = originalFetch(key, { credentials: 'same-origin' }).then(function (response) {
      return response.text().then(function (body) {
        if (!response.ok) cache.delete(key);
        return {
          body: body,
          status: response.status,
          statusText: response.statusText,
          contentType: response.headers.get('content-type') || 'text/html; charset=utf-8',
        };
      });
    });

    promise.catch(function () {
      cache.delete(key);
    });

    cache.set(key, { time: Date.now(), promise: promise });
    if (cache.size > MAX_ENTRIES) cache.delete(cache.keys().next().value);
    return promise;
  }

  function toResponse(data) {
    var emptyBody = data.status === 204 || data.status === 205 || data.status === 304;
    return new Response(emptyBody ? null : data.body, {
      status: data.status,
      statusText: data.statusText,
      headers: { 'Content-Type': data.contentType },
    });
  }

  window.fetch = function (input, init) {
    var key;
    try {
      key = variantUrl(input, init);
    } catch (e) {
      key = null;
    }
    if (!key) return originalFetch(input, init);

    var signal = init && init.signal;
    if (signal && signal.aborted) return Promise.reject(abortError());

    var pending = load(key).then(toResponse);
    if (!signal) return pending;

    return new Promise(function (resolve, reject) {
      function onAbort() {
        reject(abortError());
      }
      signal.addEventListener('abort', onAbort, { once: true });
      pending.then(
        function (response) {
          signal.removeEventListener('abort', onAbort);
          resolve(response);
        },
        function (error) {
          signal.removeEventListener('abort', onAbort);
          reject(error);
        }
      );
    });
  };

  /* ---------- Precarga ---------- */

  /**
   * Selectores que sí precargamos: el de la página de producto y el del producto destacado
   * de la portada. Devuelve el id de sección (o '' para la página de producto) o null.
   */
  function pickerSection(picker) {
    if (!picker.dataset.productUrl) return null;
    if (picker.closest('product-card, quick-add-dialog, quick-add-component, swatches-variant-picker-component')) return null;
    var featured = picker.closest('featured-product-information');
    if (featured) return featured.id || null;
    if (picker.dataset.templateProductMatch === 'true') return '';
    return null;
  }

  function isMainPicker(picker) {
    return pickerSection(picker) !== null;
  }

  /** Mismo formato de URL que usa variant-picker.js (buildRequestUrl). */
  function buildUrl(picker, optionValueIds) {
    var params = [];
    var view = new URLSearchParams(window.location.search).get('view');
    if (view) params.push('view=' + view);
    params.push('option_values=' + optionValueIds.join(','));
    var sectionId = pickerSection(picker);
    var base = picker.dataset.productUrl;
    if (sectionId) {
      base = base.split('?')[0];
      return new URL(base + '?section_id=' + sectionId + '&' + params.join('&'), window.location.href).href;
    }
    return new URL(base + '?' + params.join('&'), window.location.href).href;
  }

  /** Grupos de opciones en el mismo orden que variant-picker.js; null si no se puede precargar. */
  function optionGroups(picker) {
    var groups = [];
    var controls = picker.querySelectorAll('fieldset, select');
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      var items = control.tagName === 'SELECT' ? control.options : control.querySelectorAll('input');
      var group = [];
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        if (item.dataset.connectedProductUrl) return null; // listados combinados: no precargar
        if (item.dataset.optionValueId) {
          group.push({
            id: item.dataset.optionValueId,
            selected: control.tagName === 'SELECT' ? item.hasAttribute('selected') : item.checked,
          });
        }
      }
      if (group.length) groups.push(group);
    }
    return groups;
  }

  function combinations(groups) {
    var result = [[]];
    for (var i = 0; i < groups.length; i++) {
      var next = [];
      for (var r = 0; r < result.length; r++) {
        for (var g = 0; g < groups[i].length; g++) {
          next.push(result[r].concat(groups[i][g].id));
          if (next.length > MAX_COMBINATIONS) return null;
        }
      }
      result = next;
    }
    return result;
  }

  function prefetchAll() {
    var connection = navigator.connection;
    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

    var pickers = document.querySelectorAll('variant-picker');
    var urls = [];
    for (var i = 0; i < pickers.length; i++) {
      if (!isMainPicker(pickers[i])) continue;
      var groups = optionGroups(pickers[i]);
      if (!groups || !groups.length) continue;
      var combos = combinations(groups);
      if (!combos) continue;
      for (var c = 0; c < combos.length; c++) urls.push(buildUrl(pickers[i], combos[c]));
    }

    // Una por una, para no competir con las imágenes de la página.
    (function nextUrl(index) {
      if (index >= urls.length) return;
      load(urls[index]).then(
        function () { nextUrl(index + 1); },
        function () { nextUrl(index + 1); }
      );
    })(0);
  }

  /** Precarga la combinación que resultaría de elegir esta opción (al pasar el mouse o el dedo). */
  function prefetchIntent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var label = target.closest('variant-picker label');
    if (!label) return;
    var input = label.querySelector('input[data-option-value-id]');
    var picker = label.closest('variant-picker');
    if (!input || !picker || input.checked || !isMainPicker(picker)) return;

    var groups = optionGroups(picker);
    if (!groups) return;
    var fieldset = input.closest('fieldset');
    var ids = [];
    for (var i = 0; i < groups.length; i++) {
      var inThisGroup = false;
      for (var j = 0; j < groups[i].length; j++) {
        if (groups[i][j].id === input.dataset.optionValueId) inThisGroup = true;
      }
      if (inThisGroup && fieldset) {
        ids.push(input.dataset.optionValueId);
      } else {
        var chosen = null;
        for (var k = 0; k < groups[i].length; k++) {
          if (groups[i][k].selected) chosen = groups[i][k].id;
        }
        if (!chosen) return;
        ids.push(chosen);
      }
    }
    load(buildUrl(picker, ids));
  }

  document.addEventListener('pointerover', prefetchIntent, { passive: true });
  document.addEventListener('touchstart', prefetchIntent, { passive: true });

  function whenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 3000 });
    } else {
      setTimeout(callback, 1200);
    }
  }

  if (document.readyState === 'complete') {
    whenIdle(prefetchAll);
  } else {
    window.addEventListener('load', function () {
      whenIdle(prefetchAll);
    });
  }
})();
